import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import roles from "../features/admin/role_permmission/role/Slice";
import Owner from "../features/admin/role_permmission/owner/Slice";



const customers = combineReducers({
  roles: roles,
  Owner: Owner,

});

export default customers;